import React, { useRef } from 'react';
import { useEffect, useState } from 'react';
import {
  SEditor,
  SDrawerOrModal,
} from 'shj-components';
import { Tabs, Form, Row, Col, Select, Input, Button, Card, Modal, message, Pagination } from 'antd';
import { useLocation, useParams, useSearchParams } from 'react-router-dom'
import { checkGeneralStandard, saveBudgetDtl, DetailHouseInfoList, } from '@/services/order';
import { batchGetForAuth, batchSaveOrUpdateForAuth } from '@/services/cache'
import materialCar from '@/assets/material-car.png';
import { getUser } from '@/common/utils.ts'
import MaterialList  from './components/MaterialList';
import MaterialCar from './components/MaterialCar';
import ShowSpuDetailModal from '@/components/ShowSpuDetailModal';
import styles from './index.module.less'

export default function ChooseMaterialModal ({
  open = false,
  onClose = () => {},
  reloadList = () => ({}),
})  {
  const params = useParams()
  const budgetId = params.budgetId //报价id
  const user = getUser()
  const [loading, setLoading] = useState(false);
  const [current, setCurrent] = useState(1);
  const [chooseData, setChooseData] = useState([]);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [selectedSpuInfo, setSelectedSpuInfo] = useState({});
  const [spaceAllList, setSpaceAllList] = useState<any[]>([]);
  const [modalTitle, setModalTile] = useState('SPU信息');
  const cacheStr = `history_material_${user.workNumber}_${budgetId}` //缓存key
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  })
  const listRef = useRef<any>(null)

  useEffect(() => {
    // 获取草稿
    getCacheData()
    getAllSpace()
  }, [])

  // 获取所有空间
  const getAllSpace = async () => {
    DetailHouseInfoList({ params: { quoteBudgetId: budgetId } }).then((res) => {
      const array: any = res;
      if (!array?.length) return;
      array.forEach((item: any) => {
        //   // 添加属性
        item.checked = false;
      });
      setSpaceAllList(array);
    });
  };


  const getCacheData = async () => {
    const cacheData = await batchGetForAuth({ data: [cacheStr] });
    if (cacheData?.[cacheStr]?.value?.data?.length) {
      setChooseData(cacheData?.[cacheStr]?.value?.data);
    }
  }

  // 数据处理
  const postData = (data: any) => {
    data.map((item: any) => {
      item.quoteBudgetId = budgetId;
      item.type = item.rightMenuCode;
      // item.itemDirectoryId = tabId
      // item.tabCode = tabCode
      // 新增优惠 需要转换一个refId
      let newDynaOptions: any = {};
      if (item.dynaOptions && item.dynaOptions.length) {
        item.dynaOptions.forEach((el: any) => {
          newDynaOptions[el.key] = el.value;
        });
        item.dynaOptions = newDynaOptions;
      }
      // 提交时处理套件信息
      if (item.listDtl && item.listDtl.length) {
        item.listDtl = item.listDtl.map((el: any) => {
          return {
            srcPackDtlId: el.id,
            remark: "",
            skuCode: el.skuCode,
          };
        });
      }
       // 处理产品明细
      if (item.packDtlList?.length) {
        item.packDtlList = item.packDtlList.filter(el => el.selectSkuId)
      }
      // 空间明细字段处理
      if (item.spaceChecked && item.spaceChecked.length) {
        let array: any = [];
        item.spaceChecked.forEach((el: any) => {
          const obj = item.spaceDetailInfoList?.find((item: any) => item.elTag === el);
          array.push({
            itemId: el,
            remark: obj ? obj.remark : '',
            budgetQtyValue: (obj && obj.calculateFunc && typeof obj.calculateFunc === 'number') ? obj.calculateFunc : '',
            budgetQtyFormular: obj ? obj.calculate : '',
            reduceSourceBudgetDtlId: item.rightMenuCode === "SUB" ? item.referenceId : ''
          });
        });
        item.list = array;
      }
      if (item.rightMenuCode === 'PROJECT') {
        if (!item.spaceDetailInfoList?.length) {
          item.list = [{
            itemId: item.quoteBudgetItemId,
            remark: '',
            budgetQtyValue: '',
            budgetQtyFormular: '',
          }]
        } else {
          item.list = item.spaceDetailInfoList?.map((obj: any) => ({
            itemId: obj.elTag,
            remark: obj ? obj.remark : '',
            budgetQtyValue: (obj && obj.calculateFunc && typeof obj.calculateFunc === 'number') ? obj.calculateFunc : '',
            budgetQtyFormular: obj ? obj.calculate : '',
          })) || [];
        }
      }

      if (item.rightMenuCode === "SUB") {
        item.reduceSourceBudgetDtlId = item.referenceId;
        item.generalId = item.generalItemManageId;
        item.updateBudgetQtyFormularFlag = true; // 减项都能编辑预算量
      }

      if (item.rightMenuCode !== 'GENERAL' && item.rightMenuCode !== 'PROJECT') {
        item.refItemId = item.rootId;
      }

      if (item.rightMenuCode === 'ACTIVITY') {
        item.activityId = item.activity?.id;
        item.activityProductId = item.activityProduct?.id;
        delete item.generalId;
      }
    });
    return data;
  };

  const msgDialog  = async (msg: string) : Promise<boolean> => {
    return new Promise((resolve,reject)=>{
      Modal.confirm({
        title: "提示",
        content: msg,
        closable: true,
        okText: "确认",
        cancelText: "取消",
        centered: true,
        onOk() {
          resolve(true);
        },
        onCancel() {
          resolve(false);
        },
      })
    })
  };

  const onSubmit = async () => {
    try {
      const submitData = postData(chooseData)
      const filterList = submitData?.filter((item: any) => item.checked);
      const unSubmitData = submitData?.filter((item: any) => !item.checked);
      if (!filterList?.length) {
        message.error('请至少勾选一项');
        return;
      }
      setLoading(true);
      const res: any = await checkGeneralStandard(filterList)
      if (res) {
        const isContinue = await msgDialog(res)
        if (!isContinue) {
          setLoading(false);
          return;
        }
      }
      const submitRes: Array<any> = await saveBudgetDtl({ data: filterList })
      message.success('保存选材成功');
      setLoading(false)
      reloadList();
  
      if (!submitRes?.length) {
        setChooseData([...unSubmitData]);
        await batchSaveOrUpdateForAuth({
          data: [
            {
              key: cacheStr,
              value: {
                data: [...unSubmitData],
              },
            },
          ],
        });
      } else {
        // 有数据 说明其中有几项失效了 没加起
        const spuIds = submitRes?.map(item => item.productSpuId);
        const leaveList = filterList?.filter(item => spuIds.includes(item?.productSpu?.id))?.map(item => ({ ...item, checked: false, disabled: true }));
        setChooseData([...unSubmitData, ...leaveList]);
        await batchSaveOrUpdateForAuth({
          data: [
            {
              key: cacheStr,
              value: {
                data: [...unSubmitData, ...leaveList],
              },
            },
          ],
        });
      }
    } catch (err) {
      setLoading(false);
    }
  }

  const onSaveCache = async () => {
    await  batchSaveOrUpdateForAuth({
      data: [
        {
          key: cacheStr,
          value: {
            data: [...chooseData],
          },
        },
      ],
    });
    message.success('保存草稿成功')
  }

    const onChangePage = (page, pageSize) => {
    let pageInfo = { ...pagination }
    pageInfo.current = page
    pageInfo.pageSize = pageSize
    listRef.current?.fetchList('',null,pageInfo)
    setPagination({
      ...pagination,
      ...pageInfo,
    })
  }

  const onShowSizeChange = (current,size)=>{
    console.log(current,size);
  }
  return (
    <SDrawerOrModal
      mode="drawer"
      open={open}
      onCancel={() => onClose()}
      loading={loading}
      width={1075}
      title="新增选材"
      antdProps={{
        footer: (
          <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%'}}>
            {current === 1 ? <div style={{ display: 'flex', alignItems: 'center' }}>
              <span>已加购</span>
              <div className={styles.shopIcon}>
                <img
                  style={{ width: '24px', height: '24px' }}
                  src={materialCar}
                ></img>
                <div className={styles.shopIconNumber}>{ chooseData?.length || '0' }</div>
              </div>
              {listRef.current?.type !=='SUB' && listRef.current?.type !=='ACTIVITY' &&
                     <Pagination
                  
                      total={pagination.total}
                      current={pagination.current}
                      pageSize={pagination.pageSize}
                      showSizeChanger
                      showQuickJumper={true}
                      showTotal={total => `当前共 ${total} 条数据`}
                      onChange={onChangePage}
                      pageSizeOptions={[10, 20,50, 100]}
                      style={{marginLeft: '40px'}}
                        /> }
                 
            </div> : <div></div>}
            <div>
              {current === 1 ? <Button onClick={() => { onClose() }}>取消</Button> : null}
              {current === 2 ? <Button onClick={() => { setCurrent(1) }}>上一步</Button> : null}
              {current === 1 ? <Button type="primary" onClick={() => { setCurrent(2) }} style={{ marginLeft: '10px' }}>下一步</Button> : null}
              {current === 2 ? <Button onClick={() => {onSaveCache()}} style={{ marginLeft: '10px' }}>保存草稿</Button> : null}
              {current === 2 ? <Button type="primary" onClick={() => {onSubmit()}} style={{ marginLeft: '10px' }}>加入选材</Button> : null}
            </div>
          </div>
        )
      }}
    >
      <div style={{ display: current === 1 ? 'block' : 'none', height: '100%' }}>
        <MaterialList
          setLoading={setLoading}
          spaceAllList={spaceAllList}
          selectMaterialArray={chooseData}
          setSelectMaterialArray={setChooseData}
          setSelectedSpuInfo={setSelectedSpuInfo}
          setModalTile={setModalTile}
          setShowDetailModal={setShowDetailModal}
          pagination={pagination}
          setPagination={setPagination}
          ref={listRef}
        />
      </div>
      <div style={{ display: current === 2 ? 'block' : 'none' }}>
        <MaterialCar
          data={chooseData}
          spaceAllList={spaceAllList}
          setData={setChooseData}
          setSelectedSpuInfo={setSelectedSpuInfo}
          setModalTile={setModalTile}
          setShowDetailModal={setShowDetailModal}
          selectSpuInfo={selectedSpuInfo}
        />
      </div>
      {
        showDetailModal ? <ShowSpuDetailModal title={modalTitle} open={showDetailModal} info={selectedSpuInfo} onClose={() => { setShowDetailModal(false) }} /> : null
      }
    </SDrawerOrModal>
  )
}